import { useEffect } from 'react';

/** Prevents the page behind a drawer or modal from scrolling while it is open. */
export function useLockBodyScroll(isLocked: boolean): void {
  useEffect(() => {
    if (!isLocked) return;

    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previous;
    };
  }, [isLocked]);
}
